import { create } from "zustand";
import { persist } from "zustand/middleware";
import { authAPI } from "../features/auth/authAPI";

const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      loading: false,
      error: null,

      // Set user and token
      setUser: (user, token) => {
        set({
          user,
          token,
          isAuthenticated: true,
          error: null,
        });
      },

      // Clear user data
      clearUser: () => {
        set({
          user: null,
          token: null,
          isAuthenticated: false,
          error: null,
        });
      },

      // Login
      login: async (credentials) => {
        set({ loading: true, error: null });

        try {
          const result = await authAPI.login(credentials);

          if (result.success) {
            set({
              user: result.data.user,
              token: result.data.token,
              isAuthenticated: true,
              loading: false,
              error: null,
            });
            return { success: true };
          } else {
            set({ loading: false, error: result.error });
            return { success: false, error: result.error };
          }
        } catch (error) {
          const errorMessage = "Đã xảy ra lỗi không mong muốn";
          set({ loading: false, error: errorMessage });
          return { success: false, error: errorMessage };
        }
      },

      // Register
      register: async (userData) => {
        set({ loading: true, error: null });

        try {
          const result = await authAPI.register(userData);

          if (result.success) {
            set({
              user: result.data.user,
              token: result.data.token,
              isAuthenticated: true,
              loading: false,
              error: null,
            });
            return { success: true };
          } else {
            set({ loading: false, error: result.error });
            return { success: false, error: result.error };
          }
        } catch (error) {
          const errorMessage = "Đã xảy ra lỗi không mong muốn";
          set({ loading: false, error: errorMessage });
          return { success: false, error: errorMessage };
        }
      },

      // Logout
      logout: () => {
        authAPI.logout();
        set({
          user: null,
          token: null,
          isAuthenticated: false,
          error: null,
        });
      },

      // Get profile
      getProfile: async () => {
        set({ loading: true, error: null });

        try {
          const result = await authAPI.getProfile();

          if (result.success) {
            set({
              user: result.data,
              loading: false,
              error: null,
            });
            return { success: true, data: result.data };
          } else {
            set({ loading: false, error: result.error });
            return { success: false, error: result.error };
          }
        } catch (error) {
          const errorMessage = "Đã xảy ra lỗi không mong muốn";
          set({ loading: false, error: errorMessage });
          return { success: false, error: errorMessage };
        }
      },

      // Check if user is admin
      isAdmin: () => {
        const { user } = get();
        return user?.role === "admin";
      },

      // Initialize auth state on app start
      initAuth: async () => {
        const token = localStorage.getItem("token");
        if (token) {
          set({ loading: true, token, isAuthenticated: true });
          const result = await get().getProfile();
          if (!result.success) {
            get().clearUser();
          }
        }
      },
    }),
    {
      name: "auth-store",
      partialize: (state) => ({
        user: state.user,
        token: state.token,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);

export { useAuthStore };
